import { useState, useCallback, useRef, useEffect } from 'react';

const RESET_DELAY = 2000;

export function useCopyToClipboard() {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const copy = useCallback((text: string) => {
    void navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), RESET_DELAY);
    });
  }, []);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return { copied, copy } as const;
}
